import React from "react";
import { NavLink } from "react-router-dom";
import { warmUpApi } from "../lib/api";

export default function Navbar() {
  return (
    <header className="nav">
      <div className="nav__inner">
        <NavLink to="/" className="brand">
          <img
            src={`${process.env.PUBLIC_URL}/triggerflow-mark.svg`}
            alt=""
            width="32"
            height="32"
            aria-hidden="true"
          />
          TriggerFlow
        </NavLink>

        <nav className="nav__links" aria-label="Main navigation">
          <NavLink to="/" end className="nav__link">Home</NavLink>
          <NavLink to="/services" className="nav__link">Services</NavLink>
          <NavLink
            to="/contact"
            className="nav__link btn btn--primary"
            onMouseEnter={warmUpApi}
            onFocus={warmUpApi}
          >
            Contact
          </NavLink>
        </nav>
      </div>
    </header>
  );
}
